import { render, staticRenderFns } from "./LotteryDemo.vue?vue&type=template&id=cc9056a8&scoped=true&"
import script from "./LotteryDemo.vue?vue&type=script&lang=ts&"
export * from "./LotteryDemo.vue?vue&type=script&lang=ts&"
import style0 from "./LotteryDemo.vue?vue&type=style&index=0&id=cc9056a8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc9056a8",
  null
  
)

export default component.exports